import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  mode: "2D",
};

export const measuresSlice = createSlice({
  name: "measures",
  initialState,
  reducers: {
    setMeasureMode: (state, action) => {
      state.mode = action.payload;
    },
  },
});

export const getUniqueName = (name, measures) => {
  const names = measures.map((measure) => measure.name);
  let uniqueName = name;
  let i = 1;
  while (names.includes(uniqueName)) {
    uniqueName = `${name} (${i})`;
    i++;
  }
  return uniqueName;
};

export const { setMeasureMode } = measuresSlice.actions;

export default measuresSlice.reducer;
